import { useQuery } from "@tanstack/react-query";
import {
  FileMetaDataDto,
  FormBaseType,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_PROCUREMENT } from "../domain";

import { procurementApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_PROCUREMENT_SUPPLIERS_REPORTS_METADATA =
  "GET_PROCUREMENT_SUPPLIERS_REPORTS_METADATA";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

interface GetProcurementSuppliersReportsMetadata {
  formBaseTypes: FormBaseType[];
}

export const getReportsMetadata = async (
  params: GetProcurementSuppliersReportsMetadata,
): Promise<FileMetaDataDto[]> => {
  const { formBaseTypes } = params;

  // TODO: Fix type on BE
  const response =
    await procurementApi.procurementControllerGetSupplierReportsMetaData(
      // @ts-expect-error - Fix type on BE
      formBaseTypes,
    );

  return response.data;
};

export const useGetProcurementSuppliersReportsMetadata = (
  user: UserProfileDto | null,
  params: GetProcurementSuppliersReportsMetadata,
): {
  reportsMetadata: FileMetaDataDto[] | undefined;
  reportsMetadataEnabled: boolean;
  isLoadingReports: boolean;
  isFetchingReports: boolean;
  isSuccessReports: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryResult = useQuery({
    queryKey: [
      DOMAIN_PROCUREMENT,
      ACTION_GET_PROCUREMENT_SUPPLIERS_REPORTS_METADATA,
      ...params.formBaseTypes,
    ],
    queryFn: () => getReportsMetadata(params),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    select: (response) => response,
    enabled,
  });

  return {
    reportsMetadata: queryResult.data,
    reportsMetadataEnabled: enabled,
    isLoadingReports: queryResult.isLoading,
    isFetchingReports: queryResult.isFetching,
    isSuccessReports: queryResult.isSuccess,
  };
};
